<template>
  <div class="main-panel">
    <div class="content-wrapper dashboard-shell">
      <div class="cardplay productos-card horizontal-scrollable">
        <div class="row dashboard-header g-3 align-items-center mb-4">
          <div class="col-lg-7 col-md-8">
            <div class="d-flex align-items-center gap-2 mb-1">
              <span class="header-icon"><i class="fa-solid fa-box-open"></i></span>
              <h2 class="dashboard-title mb-0">Productos</h2>
            </div>
            <p class="productos-subtitle mb-0">Consulta y administra el listado de productos de crédito.</p>
          </div>
          <div class="col-lg-5 col-md-4 text-md-end d-flex justify-content-md-end justify-content-start">
            <router-link to="/producto/nuevo" class="btn btn-dark dashboard-action-btn">
              <i class="fa-solid fa-plus me-2"></i> Crear producto
            </router-link>
          </div>
        </div>

        <div class="table-wrapper">
          <table class="table table-hover align-middle mb-0 productos-table" id="productosTable">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Descripción</th>
                <th>Estado</th>
                <th class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody v-if="ready && productos.length > 0">
              <tr v-for="producto in productos" :key="producto.id">
                <td>#{{ producto.id }}</td>
                <td>{{ producto.nombre }}</td>
                <td>{{ producto.descripcion }}</td>
                <td>
                  <span class="badge" :class="producto.activo ? 'bg-success' : 'bg-secondary'">
                    {{ producto.activo ? 'Activo' : 'Inactivo' }}
                  </span>
                </td>
                <td class="text-center">
                  <router-link class="btn btn-sm btn-inverse-primary" :to="`/producto/nuevo?id=${producto.id}`">
                    Ver más
                  </router-link>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="ready && productos.length === 0">
              <tr>
                <td colspan="5" class="text-center py-4">No hay productos para mostrar.</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5" class="text-center py-4">
                  <div class="spinner-border text-warning" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTables from 'datatables.net';
import { store } from '../store';

export default {
  name: 'Productos-App',
  data() {
    return {
      productos: [],
      ready: false,
      tableInitialized: false,
      datatableLanguage: {
        lengthMenu: 'Mostrar _MENU_ registros',
        search: 'Buscar:',
        info: 'Mostrando _START_ a _END_ de _TOTAL_ registros',
        infoEmpty: 'Mostrando 0 a 0 de 0 registros',
        infoFiltered: '(filtrado de _MAX_ registros totales)',
        zeroRecords: 'No se encontraron resultados',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último',
        },
      },
    };
  },
  beforeMount() {
    this.fetchData();
  },
  updated() {
    if (this.ready && !this.tableInitialized && this.productos.length > 0) {
      this.initializeDataTable();
    }
  },
  methods: {
    fetchData() {
      const endpoints = ['/productos/all', '/admin/productos/all'];
      this.fetchDataFromEndpoints(endpoints, 0);
    },
    fetchDataFromEndpoints(endpoints, index) {
      if (index >= endpoints.length) {
        this.ready = true;
        alert('No se pudieron cargar los productos.');
        return;
      }
      const headers = new Headers();
      headers.append('Authorization', 'Bearer ' + store.token);
      fetch(process.env.VUE_APP_API_URL + endpoints[index], { method: 'GET', headers })
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.fetchDataFromEndpoints(endpoints, index + 1);
            return;
          }
          this.productos = response.data?.productos || response.data || [];
          this.ready = true;
        })
        .catch(() => {
          this.fetchDataFromEndpoints(endpoints, index + 1);
        });
    },
    initializeDataTable() {
      const table = document.querySelector('#productosTable');
      if (table && !this.tableInitialized) {
        new DataTables(table, {
          language: this.datatableLanguage,
        });
        this.tableInitialized = true;
      }
    },
  },
};
</script>

<style scoped>
.productos-card {
  padding: 24px;
  background: #ffffff;
  border: 1px solid #dfe8e3;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(28, 45, 36, 0.08);
}

.dashboard-header {
  padding: 20px;
  background: #f4faf7;
  border: 1px solid #dbe8e1;
  border-radius: 8px;
}

.header-icon {
  width: 50px;
  height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #1f6f4f;
  color: #ffffff;
  border-radius: 8px;
  font-size: 1.55rem;
  box-shadow: 0 10px 20px rgba(31, 111, 79, 0.18);
}

.dashboard-title {
  color: #1f2d28;
  font-weight: 800;
}

.productos-subtitle {
  color: #60746a;
}

.dashboard-action-btn {
  border-radius: 8px;
  padding: 0.7rem 1rem;
}

.table-wrapper {
  padding: 16px;
  background: #fbfdfc;
  border: 1px solid #e0e9e4;
  border-radius: 8px;
  overflow-x: auto;
}

.productos-table {
  border-collapse: separate;
  border-spacing: 0;
}

.productos-table thead th {
  background: #263a31;
  color: #ffffff;
  border: 0;
  padding: 14px 16px;
  font-weight: 700;
}

.productos-table thead th:first-child {
  border-top-left-radius: 8px;
}

.productos-table thead th:last-child {
  border-top-right-radius: 8px;
}

.productos-table tbody td {
  padding: 14px 16px;
  border-bottom: 1px solid #edf2ef;
}

.productos-table tbody tr:hover td {
  background: #f4faf7;
}

.productos-table .btn {
  border-radius: 8px;
}

:deep(.dataTables_length),
:deep(.dt-length) {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 4px 0 18px;
  text-align: center;
  float: none !important;
}

:deep(.dt-layout-row:first-child) {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.dt-layout-row:first-child .dt-layout-cell) {
  display: flex;
  justify-content: center;
}

:deep(.dataTables_length label),
:deep(.dt-length label) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0;
  color: #51665d;
  font-weight: 600;
}

:deep(.dataTables_length select),
:deep(.dt-length select) {
  width: auto;
  min-width: 70px;
  border: 1px solid #d7e1dc;
  border-radius: 8px;
  padding: 6px 10px;
}

:deep(.dataTables_filter),
:deep(.dt-search) {
  margin-bottom: 16px;
}

:deep(.dataTables_filter input),
:deep(.dt-search input) {
  border: 1px solid #d7e1dc;
  border-radius: 8px;
  padding: 7px 10px;
}

:deep(.dataTables_info),
:deep(.dt-info) {
  color: #60746a;
  padding-top: 16px;
}

:deep(.dataTables_paginate),
:deep(.dt-paging) {
  padding-top: 12px;
}

@media (max-width: 768px) {
  .productos-card {
    padding: 14px;
  }

  .dashboard-header {
    padding: 16px;
  }

  .header-icon {
    width: 44px;
    height: 44px;
    font-size: 1.35rem;
  }
}
</style>
